import { Switch } from '@components/ui/switch'

interface AutoSpacingToggleProps {
  checked: boolean
  canAutoDistribute: boolean
  selectedCount: number
  onCheckedChange: (checked: boolean) => void
}

export function AutoSpacingToggle({
  checked,
  canAutoDistribute,
  selectedCount,
  onCheckedChange,
}: AutoSpacingToggleProps) {
  return (
    <>
      <div className="flex items-center justify-between gap-3">
        <label
          htmlFor="auto-distribute"
          className="text-sm font-medium text-foreground leading-none"
        >
          Auto spacing
        </label>
        <Switch
          id="auto-distribute"
          checked={checked}
          disabled={!canAutoDistribute}
          onCheckedChange={onCheckedChange}
          title={
            canAutoDistribute
              ? 'Automatically equalize gaps between selected objects'
              : 'Select at least three objects to auto distribute'
          }
        />
      </div>
      {!canAutoDistribute && selectedCount > 0 && (
        <p className="text-xs text-muted-foreground leading-snug">
          Select at least three objects to auto distribute.
        </p>
      )}
    </>
  )
}
